module.exports = __webpack_public_path__ + "static/img/3.e312f4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/3.jpg
// module id = bnS0
// module chunks = 2